var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1105,
    height: 283,
    viewBox: "0 0 1105 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5031_16606)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1105,
    height: 283,
    fill: "#3B5F59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.82 310.9C-105.82 310.9 -76.6765 205.847 -24.3715 169.365C33.4366 129.044 94.6727 184.607 154.821 147.869C208.262 115.228 195.898 49.2108 251.095 19.6373C313.033 -13.548 369.186 53.1148 431.027 19.7491C495.37 -14.966 530.255 -139 530.255 -139",
    stroke: "#375853",
    strokeWidth: 82,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1803 457.9C18.1803 457.9 47.3235 352.847 99.6285 316.365C157.437 276.044 218.673 331.607 278.821 294.869C332.262 262.228 319.898 196.211 375.095 166.637C437.033 133.452 493.186 200.115 555.027 166.749C619.37 132.034 654.255 7.99998 654.255 7.99998",
    stroke: "#375853",
    strokeWidth: 82,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.894 666.15C418.894 666.15 428.954 529.666 484.378 471.901C545.632 408.059 634.67 461.411 699.686 401.404C757.451 348.089 726.007 269.859 786.689 219.889C854.781 163.816 940.289 232.08 1008.22 175.809C1078.89 117.262 1091.36 -44 1091.36 -44",
    stroke: "#375853",
    strokeWidth: 82,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5031_16606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1105,
    height: 283,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImage);
export default __webpack_public_path__ + "static/media/bgImage.adab196956495f55735d39e4b15781f4.svg";
export { ForwardRef as ReactComponent };